import styled from "styled-components";
import {
  PrimaryButtonComponent,
  GhostButtonComponent,
  GhostBackButtonComponent,
  LinkNavigator
} from "../commonStyles";

export const Arrow = styled.div`
  display: inline-block;
  position: relative;
  left: 10px;    
  bottom: 2px;
  transition: left 0.2s;

  @media only screen and (max-width: 990px) {
    left: 5px;
  }
  @media only screen and (max-width: 576px) {
    left: 5px;
  }
`;

export const LeftArrow = styled.div`
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  right: 10px;
  -webkit-transition: right 0.2s;
  transition: right 0.2s;
  @media only screen and (max-width: 990px) {
    right: 5px;
  }
  @media only screen and (max-width: 576px) {
    right: 5px;
  }
`;

export const PrimaryButtonWrapper = styled(PrimaryButtonComponent)`
  &:hover {
    background-color: ${props => props.theme.colors.ctaHover};
  }
  .new_arrow {
    border: 0;
    cursor: pointer;
    padding: 0;
    height: 8px;
    width: 25px;
    outline: none;
    background: transparent;
    display: inline-block;
    ${props => props.leftArrow ? 'margin-right: 15px;' : 'margin-left: 15px;'}
    ${props => props.leftArrow && 'transform: rotate(180deg)'}
  }
  .arrow_line {
      width: 15px;
      height: 2px;
      top: 2px;
      left: 0px;
      position: relative;
      display: block;
      background: ${props => props.color ? props.color : props.theme.backgroundColor.layoutLight};
      z-index: 1;
      transition: all 0.4s ease-in-out;
  }
  .arrow_line span {
      bottom: -3px;
      right: 0px;
      border: solid ${props => props.color ? props.color : props.theme.backgroundColor.layoutLight};
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      position: absolute;
      z-index: 5;
      transition: all 0.4s ease-in-out;
  }
  &:hover{
    span.arrow_line {
      width: 25px;
      left: 0;
    }
  }

  &:disabled{
    background-color: ${props => props.theme.backgroundColor.summaryDivider};
  }
`;

export const GhostButtonWrapper = styled(GhostButtonComponent)`
  .new_arrow {
    border: 0;
    cursor: pointer;
    padding: 0;
    height: 8px;
    width: 25px;
    outline: none;
    background: transparent;
    display: inline-block;
    ${props => props.leftArrow ? 'margin-right: 15px;' : 'margin-left: 15px;'}
    ${props => props.leftArrow && 'transform: rotate(180deg)'}
  }
  .arrow_line {
      width: 15px;
      height: 2px;
      top: 2px;
      left: 0px;
      position: relative;
      display: block;
      background: ${props => props.theme.backgroundColor.primaryColor};
      z-index: 1;
      transition: all 0.4s ease-in-out;
  }
  .arrow_line span {
      bottom: -3px;
      right: 0px;
      border: solid ${props => props.theme.border.teal};
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      position: absolute;
      z-index: 5;
      transition: all 0.4s ease-in-out;
  }
  &:hover{
    span.arrow_line {
      width: 25px;
      left: 0;
    }
  }
`;

export const GhostBackButtonWrapper = styled(GhostBackButtonComponent)`
  &.ant-btn {
    border-radius: 0px;
    .anticon {
      transition: right 0.2s;
    }
  }
  transition: right 0.2s linear;
  &:hover ${LeftArrow} {
    right: 20px;
    transition: right 0.2s;
  }
  @media only screen and (max-width: 990px) {
    width: 100%!important;
    &:hover ${LeftArrow} {
      right: 10px;
      transition: right 0.2s;
    }
  }
  @media only screen and (max-width: 576px) {
    &:hover ${LeftArrow} {
      right: 10px;
      transition: right 0.2s;
    }
  }
`;

export const LinkNavigatorWrapper = styled(LinkNavigator)`
  display: flex;
  align-items: center;
  .new_arrow {
    border: 0;
    cursor: pointer;
    padding: 0;
    height: 8px;
    width: 25px;
    outline: none;
    background: transparent;
    display: inline-block;
    ${props => props.leftArrow ? 'margin-right: 15px;' : 'margin-left: 15px;'}
    ${props => props.leftArrow && 'transform: rotate(180deg)'}
  }
  .arrow_line {
      width: 15px;
      height: 2px;
      top: 2px;
      left: 0px;
      position: relative;
      display: block;
      background: ${props => props.disabled ? props.theme.colors.lightGrey : props.color};
      z-index: 1;
      transition: all 0.4s ease-in-out;
  }
  .arrow_line span {
      bottom: -3px;
      right: 0px;
      border: solid ${props => props.disabled ? props.theme.colors.lightGrey : props.color};
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: 3px;
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
      position: absolute;
      z-index: 5;
      transition: all 0.4s ease-in-out;
  }
  &:hover{
    span.arrow_line {
      width: 25px;
      left: 0;
    }
  }
`;

export const EditButton = styled(GhostButtonComponent)`
  display: flex;
  align-self: center;
  justify-content: center;
  width: 71px;
  height: 23px;
  padding-top: 2px;
  border-radius: 18px !important;
  border: solid 1px ${props => props.theme.border.pill};
  background-color: ${props => props.theme.backgroundColor.pill};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  text-transform: capitalize;
  font-family: ${props => props.mediumFont ? props.theme.fontFamily.helveticaNeueMedium : props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.secondary};
  margin-top: 3px;
  span {
    line-height: ${props => props.theme.lineHeight.normal};
  }
`;

export const CSREditButton = styled(GhostButtonComponent)`
  display: flex;
  align-self: center;
  justify-content: center;
  width: 104px;
  height: 23px;
  border-radius: 1.125rem !important;
  border: solid 1px ${props => props.theme.border.csrPill};
  background-color: ${props => props.theme.backgroundColor.oleGeminiColor};
  text-transform: initial;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.secondary};
  text-transform: capitalize;
  margin-top: 3px;
  &:hover,
  :focus {
    background-color: ${props => props.theme.backgroundColor.oleGeminiColor};
    color: ${props => props.theme.colors.primaryColor};
    border: solid 1px ${props => props.theme.border.csrPill};
  }
  span {
    line-height: ${props => props.theme.lineHeight.normal};
  }
`;

export const EditIcon = styled.div`
  margin: -4px 0 0 5px;
`;

export const BackButtonArrow = styled.img`
    width: 15px;
    height: 9px;
`
export const RoundWrapper = styled.div`
  display: flex;
  height: 30px;
  justify-content: space-between;
  align-items: center;
  width: fit-content;
  border: solid 1px ${props => props.theme.colors.border};
  background-color: ${props => props.theme.backgroundColor.pill};
  border-radius: 18px;
  padding: 6px 20px;
  cursor: pointer;
  > span {
    font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
    font-size: ${props => props.theme.fontSize.secondary};
    color: ${props => props.theme.fontColors.primary};
    padding-right: 10px;
  }

&.disabled_button span {
    color: rgba(0, 0, 0, 0.25);
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    text-shadow: none;
    box-shadow: none;
    cursor: not-allowed;
}

`;

export const ShowMoreWrapper = styled.div`
  >button {
    padding: 0px 20px;
    width: 134px;
    justify-content: space-between;
    >span {
      text-align: left;
    }
  }
`;

export const EditButtonWrap = styled.div`
  ${props => props.boldFont && `
    >button >span {
      font-family: ${props.theme.fontFamily.helveticaNeueBold};
    }
  `}
`;